import React from 'react';
import { useRoSContext } from '@components/Presentation/context/RoSContext';
import Switch from '@molecules/Switch';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import Tooltip from '@components/Presentation/atoms/Tooltip';
import { type InteractionSettings } from '@components/Presentation/types';

function ShowProfilePictures({ settingKey }: { settingKey: keyof InteractionSettings }) {
  const { selectedSlide } = useRoSContext();
  return (
    <div className="flex">
      <div className="flex-1 text-sm">
       Display profile pictures &nbsp;
        <Tooltip content="Show profile pictures to help identify participants.">
          <HelpRoundedIcon
            fontSize="small"
            color="disabled"
            className='dark:text-grey-400'
          />
        </Tooltip>
      </div>
      <Switch
        checked={!!selectedSlide?.setting?.[settingKey]}
        onChange={(e) =>
          selectedSlide.handler.updateSetting(
            settingKey,
            e.target.checked
          )
        }
        onClick={() => {}}
      />
    </div>
  );
}

export default ShowProfilePictures;
